module.exports = __webpack_public_path__ + "static/img/jzwftLogoN.10e9be5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jzwftLogoN.jpg
// module id = Y4Jc
// module chunks = 2